import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const downloadExcelGeneric = ({ fileName, sheet, tablePayload }) => {
  const { header, body } = tablePayload;

  const dataFormatted = body.map(row => {
    const newRow = {};

    Object.keys(row).forEach(key => {
      const value = row[key];

      if (typeof value === "number") {
        newRow[key] = Number.isInteger(value) ? value : parseFloat(value.toFixed(2));
      } else {
        newRow[key] = value;
      }
    });

    return newRow;
  });

  const worksheet = XLSX.utils.json_to_sheet(dataFormatted, { header, dense: false });
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheet ?? "Datos");

  const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array", cellStyles: false });
  const blob = new Blob([buffer], { type: "application/octet-stream" });
  saveAs(blob, `${fileName}.xlsx`);
};